const ManagerNavData = [
    {
        title: "Profile",
        link: "/manager/profile/setting"
    },
    {
        title: "Password",
        link: "/manager/profile/change-password"
    },
    {
        title: "Logout",
        link: "/manager/profile/logout"
    }
];

export default ManagerNavData;